[
  {
    "code": "UZ-AN",
    "name": "Andijon"
  },
  {
    "code": "UZ-BU",
    "name": "Buxoro"
  },
  {
    "code": "UZ-FA",
    "name": "Farg‘ona"
  },
  {
    "code": "UZ-JI",
    "name": "Jizzax"
  },
  {
    "code": "UZ-NG",
    "name": "Namangan"
  },
  {
    "code": "UZ-NW",
    "name": "Navoiy"
  },
  {
    "code": "UZ-QA",
    "name": "Qashqadaryo"
  },
  {
    "code": "UZ-QR",
    "name": "Qoraqalpog‘iston Respublikasi"
  },
  {
    "code": "UZ-SA",
    "name": "Samarqand"
  },
  {
    "code": "UZ-SI",
    "name": "Sirdaryo"
  },
  {
    "code": "UZ-SU",
    "name": "Surxondaryo"
  },
  {
    "code": "UZ-TO",
    "name": "Toshkent"
  },
  {
    "code": "UZ-TK",
    "name": "Toshkent City"
  },
  {
    "code": "UZ-XO",
    "name": "Xorazm"
  }
]